"use strict";

export function initInScope ($scope) {
    $scope.find('.js-number-spinner__down').on('click', function (evt) {
        countDown(evt, $(this));
    });

    $scope.find('.js-number-spinner__up').on('click', function (evt) {
        countUp(evt, $(this));
    });

    $scope.find('.js-number-spinner__input').on('change', function (evt) {
        var $input = $(this);
        var value = Number($input.val());

        if(isNaN(value)) {
            value = 1;
        };

        $input.val(Math.max(value,0));
    });

    function countUp(evt,_this){
        var input = _this.closest('.js-number-spinner').find('.js-number-spinner__input');
        var maxValue = parseInt(input.attr('data-max'));
        input.val(+input.val()+1);
        input.trigger('change');

        if(input.val() >= maxValue) {
            input.val(maxValue);
            //evt.stopImmediatePropagation();
        }

        evt.preventDefault();
    }

    function countDown(evt, _this){
        var input = _this.closest('.js-number-spinner').find('.js-number-spinner__input');

        if(input.attr('data-min')) {
            var minValue = parseInt(input.attr('data-min'));
        } else {
            var minValue = 1;
        }

        input.val(Math.max(+input.val()-1));
        input.trigger('change');

        console.log(minValue);
        console.log(input.val());


        if(input.val() <= minValue) {
            input.val(minValue);
            //evt.stopImmediatePropagation();
        }

        evt.preventDefault();
    }
}